import { Navigate } from "react-router-dom";

const NotFound = () => <Navigate to="/" replace />;

export default NotFound;
